import { Store, StoresResponse, convertStore } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCompanyStores(companyId: string | undefined) {
  const { server } = useServer()
  const query = useQuery<Store[]>({
    queryKey: keys.companyStores(companyId),
    queryFn: fetchCompanyStores,
    enabled: !!companyId,
  })

  return query

  async function fetchCompanyStores() {
    if (!companyId) {
      throw new Error('Company id invalid')
    }
    const response = await server.get<StoresResponse.Store[]>(
      `/v2/companies/${companyId}/stores`
    )
    return response
      ?.map(convertStore)
      .sort((a, b) => Number(a.storeNumber) - Number(b.storeNumber))
  }
}
